<script setup>
defineProps({
  alignItems: {
    type: String,
    default: 'center',
  },
})
</script>

<template>
  <div
    :class="{
      [$style.row]: true,
      [$style[alignItems]]: !!alignItems,
    }"
    hide-empty
  >
    <slot />
  </div>
</template>

<style module lang="scss">
.row {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 1rem;
  &.center {
    align-items: center;
  }
  &.start {
    align-items: flex-start;
  }
  &.end {
    align-items: flex-end;
  }
  &.stretch {
    align-items: stretch;
  }
}
</style>
